module.exports = __webpack_public_path__ + "img/blueprint.0f6f39ba.svg";